<template>
  <div class="product-right-pannel">
    <div class="settle__right" v-if="isCustomer">
      <el-image class="settle__right__img" fit="cover" src="~assets/img/customer/product_right_settle_bg.png"></el-image>
      <div class="settle__right__btn" @click="showLogin">
        我要合作
      </div>
    </div>
    <div class="distributor" v-show="affixd">
      <div class="distributor__sale">
        <span class="distributor__sale__label">售价:</span>
        <div>
          <span class="distributor__sale__rangin text-price">
            ￥{{ data.min_th_price }}
          </span>
          <!-- <span class="union">/人起</span> -->
          <!-- <span class="link">~</span>
          <span class="distributor__sale__rangin">
            ￥102
          </span> -->
          <span class="union">/人</span>
        </div>
      </div>
      <Profit :min_profit="data.min_profit" :max_profit="data.max_profit" />
      <div class="distributor__deadline">报名截止日期：{{data.date_end_time}}</div>
    </div>

    <div class="section__wrapper" :class="{'section__wrapper--active':isDistributor }" @click="clickPannel">
      <div class="section">
        <h5 class="section__title">
          可选航次
          <span class="section__title__sub">共{{ data.dates.total_date }}个航次</span>
        </h5>
        <ul class="packages">
          <li v-for="voyage in data.dates.dates" :key="voyage.id" class="package" :class="{
              'is-active': false,
            }">
            <div class="package-title">{{ [voyage.date, voyage.week].join('/')  }}</div>
            <div class="package-num">
              {{ voyage.last_stock | mapStockText }}
            </div>
            <div class="package-price text-price">¥ {{ voyage.price }}起/人</div>
            <v-tag v-if="voyage.date_tag" class="holiday-tag">{{
              voyage.date_tag.name
            }}</v-tag>
          </li>
        </ul>
      </div>
      <div class="section">
        <h5 class="section__title">
          可选舱房
          <span class="section__title__sub">共{{data.dates.total_cabin}}种舱房</span>
        </h5>

        <ul class="packages">
          <div class="cabin" v-for="(cabin, stockIndex) in data.dates.cabins.slice(0, 2)" :key="stockIndex">
            <el-image class="cabin-img" fit="cover" :src="cabin.cabin.images" />
            <div class="cabin-content">
              <h3 class="cabin-title">{{ cabin.cabin_name }}</h3>
              <div class="cabin-detail">
                {{ cabin.cabin.room_area }}
                <v-divider direction="vertical" />
                {{ cabin | peopleStr }}
                <br />
                {{ cabin.cabin.window_label }}
                <template v-if="cabin.cabin.window_area">
                  ({{ cabin.cabin.window_area }})
                </template>
                <v-divider direction="vertical" />{{
                  cabin.cabin.floor_label.join(",")
                }}层
              </div>
            </div>
          </div>
        </ul>
      </div>
      <div class="action">
        <el-button class="action__btn" type="primary">立即采购</el-button>
      </div>
    </div>
  </div>
</template>
<script>
import { dayjs } from "@/utils/helpers";
import Profit from "@/components/Profit.vue";
import useLoginDialog from "~/composables/useLoginDialog";

export default {
  name: "CruiseRightPannel",
  props: {
    data: {
      type: Object,
      default: () => ({
        id: "",
        product_no: "",
        tags: [],
        images: [],
        cruises_info: {
          cover: "",
          title: "",
        },
        departure: "",
        status: 1,
        in_shop: false,
        is_favorite: true,
        dates: {
          cabins: [],
          dates: [],
        },
      }),
    },
    voyageData: {
      type: Array,
      default: () => [],
    },
    stockData: {
      type: Array,
      default: () => [],
    },
    affixd: {
      // 是否是吸顶状态
      type: Boolean,
      default: false,
    },
  },
  components: {
    Profit,
  },
  setup(props, context) {
    const {showLogin} = useLoginDialog();
    return {showLogin}
  },
  filters: {
    formatDate(date) {
      if (!date) return "";

      const dateRef = dayjs(date);
      const day = dateRef.date();
      const weekDay = ["日", "一", "二", "三", "四", "五", "六"][dateRef.day()];
      console.log(date, dateRef)
      return `${day}日/周${weekDay}`;
    },
    mapStockText(value) {
      if (value > 10) {
        return "库存充足";
      }
      if (value > 0) {
        return `仅剩${value}间`;
      }
      return "1小时内确认";
    },
    peopleStr(cabin) {
      return cabin.min_people === cabin.max_people
        ? `必须入住${cabin.min_people}人`
        : [cabin.min_people, cabin.max_people].join("-") + "人";
    },
  },
  computed: {
    auth() {
      return this.$auth.$state;
    },
    loggedIn() {
      return this.$store.getters.loggedIn;
    },
    isCustomer() {
      // 直客 未登录都看作是直客
      return (
        !this.auth.loggedIn ||
        (this.auth.loggedIn && this.auth.user && !this.auth.user.distributor)
      );
    },
    isDistributor() {
      if (!this.auth.loggedIn) return false;
      return !!this.auth.user.distributor;
    },
  },
  methods: {
    // showLogin() {
    //   // this.$store.commit('setVisibleRegisterModal', true);
    // },
    clickPannel() {
      if (!this.loggedIn) {
        this.showLogin();
      }else if(!this.isDistributor){
				this.$router.push('/settled/process')
				return
			} else {
        this.$router.push({
          path: "/product/cruise/pre-booking",
          query: {
            no: this.$route.params.productNo,
          },
        });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.product-right-pannel {
  width: 346px;
  background-color: #fff;
}
.settle__right {
  position: relative;
}
.settle__right__btn {
  position: absolute;
  bottom: 24px;
  width: 175px;
  color: #212529;
  font-size: 21px;
  text-align: center;
  border-radius: 46px;
  height: 46px;
  line-height: 46px;
  background: linear-gradient(180deg, #fffd00 0%, #ffbe00 100%);
  font-weight: 600;
  left: 50%;
  transform: translateX(-50%);
  cursor: pointer;
  user-select: none;
}
.settle__right__img {
  width: 100%;
  height: 142px;
  border-radius: 6px;
}
.section {
  padding: 10px 24px;
}
.section__wrapper {
  padding: 10px 0;
  cursor: pointer;
  user-select: none;
}
.section__wrapper--active .package:first-child {
  --tw-bg-opacity: 1;
  background-color: rgba(244, 244, 244, var(--tw-bg-opacity));
  border-color: #1F2129;
  position: relative;
  color: $color-primary;
}
.section__wrapper--active .package:first-child::before {
  content: "";
  position: absolute;
  right: -20px;
  bottom: -30px;
  border: 21px solid transparent;
  border-bottom-color: #1F2129;
  transform: rotate(140deg);
}
.section__wrapper--active .package:first-child::after {
  content: "";
  position: absolute;
  right: 2px;
  bottom: 6px;
  width: 10px;
  height: 5px;
  border: 1px solid #fff;
  border-top: 0;
  border-right: 0;
  transform: rotate(-45deg);
}
.section__title {
  color: #333;
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 15px;
}
.section__title__sub {
  margin-left: 5px;
  color: #868e96;
  font-size: 13px;
  font-weight: 400;
}
.packages {
  display: flex;
  margin-top: 18px;
  overflow: hidden;
  white-space: nowrap;
  position: relative;
}
.packages::after {
  content: "";
  position: absolute;
  width: 114px;
  height: 100%;
  right: 0;
  top: 0;
  background: linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, #ffffff 100%);
}
.packages .package {
  cursor: pointer;
  position: relative;
  width: 120px;
  height: 90px;
  border-radius: 6px;
  border: $default-border;
  text-align: center;
  user-select: none;
  transition: border-color $primary-transition;
  overflow: hidden;
  flex-shrink: 0;
  margin: 0 10px 10px 0;
  font-size: 15px;
}
.packages .package:first-child {
  margin-left: 0;
}
.packages .package-title {
  color: $important-text-color;
  font-weight: 500;
  margin-top: 9px;
}
.packages .package-num {
  color: $color-grey-4;
}
.packages .package-price {
  font-weight: 500;
}
.packages .package .holiday-tag {
  position: absolute;
  left: 0;
  top: 0;
  font-size: 12px;
  padding: 0 8px;
  height: auto;
}
.packages .package.is-active {
  overflow: hidden;
}
.packages .package.is-active::before {
  content: "";
  position: absolute;
  right: -24px;
  bottom: -30px;
  border: 24px solid transparent;
  border-bottom-color: $theme-color;
  transform: rotate(135deg);
}
.packages .package.is-active::after {
  content: "";
  position: absolute;
  right: 3px;
  bottom: 6px;
  width: 10px;
  height: 5px;
  border: 1px solid #fff;
  border-top: 0;
  border-right: 0;
  transform: rotate(-45deg);
}
.cabin {
  display: flex;
  margin-right: 10px;
}
.cabin-img {
  width: 120px;
  height: 90px;
  border-radius: 6px;
  overflow: hidden;
}
.cabin-content {
  margin-left: 17px;
}
.cabin-title {
  font-size: 16px;
  font-weight: 500;
  margin: 6px 0;
  margin-top: 9px;
  color: $secondary-text-color;
}
.cabin-detail {
  line-height: 1.6;
  color: $secondary-text-color;
}
.distributor {
  padding: 20px 20px 4px;
}
.distributor__sale {
  display: flex;
  align-items: center;
  color: $highlight-color;
}
.distributor__sale__label {
  color: #49495b;
  font-size: 14px;
  font-weight: 500;
}
.distributor__sale__rangin {
  font-weight: bold;
  font-size: 24px;
}
.distributor__sale .union {
  font-size: 12px;
  display: inline-block;
  vertical-align: middle;
}
.distributor__tip {
  display: flex;
  align-items: center;
  background-color: #fdf9e5;
  border-radius: 4px;
  color: #d78b1a;
  font-size: 14px;
  padding: 6px 14px;
  margin-top: 20px;
}
.distributor__tip .ficon {
  margin-right: 5px;
}
.distributor__tip pre {
  word-break: break-all;
  white-space: pre-wrap;
  word-wrap: break-word;
}
.distributor__deadline {
  color: #495057;
  font-size: 13px;
  padding: 12px 0;
  border-bottom: 1px solid #dee2e6;
}
.action {
  padding: 15px 20px 25px;
}
.action__btn {
  width: 100%;
}
</style>
